import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";

import Papers from "./components/Papers/Papers";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import Learning from "./components/Learning/Learnings";
import DayToDayLearning from "./components/Learning/DayToDayLearning";
import TodoList from "./components/Learning/TodoList";
import Test from "./components/Learning/Test";
import LearningGraph from "./components/Learning/LearningGraph";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import MonthlyLearning from "./components/Learning/MonthlyLearning";
import LoginComponent from "./components/Login";
import Revision from "./components/Learning/Revision";
import Courses from "./components/Courses/Courses";

import API from "./utils/api";
import Skills from "./components/Skill/Skill";

function App() {
  const [load, upadateLoad] = useState(true);
  const [isAunthenticated, setIsAuthenticated] = useState(false);
  const [learning, setLearning] = useState(false);

  useEffect(() => {
    const isSessionActive = Cookies.get("user_token");
    console.log(isSessionActive);
    if (isSessionActive) {
      API.get("/api/login/verify_session")
        .then((req) => req.data)
        .then((data) => {
          if (data.tokenVerified) {
            setIsAuthenticated(true);
            console.log("token verified!");
          } else {
            console.log("token not verified!");
          }
          upadateLoad(false);
        })
        .catch((e) => {
          console.log("token not verified!");
          upadateLoad(false);
        });
    } else {
      console.log("token not verified!");
      upadateLoad(false);
    }
    // const timer = setTimeout(() => {
    // upadateLoad(false);
    // }, 1200);

    // return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        {!learning && <Navbar setLearning={setLearning} />}
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/courses" element={<Courses />} />
          <Route
            path="/skills"
            element={<Skills authenticated={isAunthenticated} />}
          />
          <Route path="/about" element={<About />} />
          <Route
            path="/resume"
            element={<Resume authenticated={isAunthenticated} />}
          />
          <Route path="/paper" element={<Papers />} />
          <Route
            path="/learning"
            element={
              !isAunthenticated ? (
                <LoginComponent
                  setIsAuthenticated={setIsAuthenticated}
                  setLearning={setLearning}
                />
              ) : (
                <Learning
                  setIsAuthenticated={setIsAuthenticated}
                  learning={learning}
                  setLearning={setLearning}
                />
              )
            }
          />
          <Route
            path="/learning/day-to-day"
            element={
              !isAunthenticated ? (
                <LoginComponent
                  setIsAuthenticated={setIsAuthenticated}
                  setLearning={setLearning}
                />
              ) : (
                <DayToDayLearning
                  setIsAuthenticated={setIsAuthenticated}
                  learning={learning}
                  setLearning={setLearning}
                />
              )
            }
          />
          <Route
            path="/learning/this-month"
            element={
              !isAunthenticated ? (
                <LoginComponent
                  setIsAuthenticated={setIsAuthenticated}
                  setLearning={setLearning}
                />
              ) : (
                <MonthlyLearning
                  setIsAuthenticated={setIsAuthenticated}
                  learning={learning}
                  setLearning={setLearning}
                />
              )
            }
          />
          <Route
            path="/learning/todo"
            element={
              !isAunthenticated ? (
                <LoginComponent
                  setIsAuthenticated={setIsAuthenticated}
                  setLearning={setLearning}
                />
              ) : (
                <TodoList
                  setIsAuthenticated={setIsAuthenticated}
                  learning={learning}
                  setLearning={setLearning}
                />
              )
            }
          />
          <Route
            path="/learning/graph"
            element={
              !isAunthenticated ? (
                <LoginComponent
                  setIsAuthenticated={setIsAuthenticated}
                  setLearning={setLearning}
                />
              ) : (
                <LearningGraph
                  setIsAuthenticated={setIsAuthenticated}
                  learning={learning}
                  setLearning={setLearning}
                />
              )
            }
          />
          <Route
            path="/learning/revision"
            element={
              !isAunthenticated ? (
                <LoginComponent
                  setIsAuthenticated={setIsAuthenticated}
                  setLearning={setLearning}
                />
              ) : (
                <Revision
                  setIsAuthenticated={setIsAuthenticated}
                  learning={learning}
                  setLearning={setLearning}
                />
              )
            }
          />
          <Route
            path="/learning/test"
            element={
              !isAunthenticated ? (
                <LoginComponent
                  setIsAuthenticated={setIsAuthenticated}
                  setLearning={setLearning}
                />
              ) : (
                <Test
                  setIsAuthenticated={setIsAuthenticated}
                  learning={learning}
                  setLearning={setLearning}
                />
              )
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
